<div class="modal__content">
    <h2>{{ $t('modals.unlock.title') }}</h2>
    <div class="form__group">
        <p v-html="$t('modals.unlock.content')"></p>
    </div>
    <div class="form__group">
        <button class="btn btn-orange" @click="closeModal('unlock')">{{ $t('modals.unlock.next') }}</button> 
    </div>

</div>
